/*
*/

  (function() {
    'use strict';

    function navbarController($rootScope, $timeout, $attrs, $pbService) {
      var vm = this;
      vm.percentageComplete = parseInt($attrs.percentageComplete, 10);
      vm.progressIsSkipped = false;
      vm.progressCircleOptions = {
        color: $rootScope.$themes[$rootScope.$currentTheme || 'pdplatform'].accentColor,
        duration: 1400,
        strokeWidth: 3,
        trailWidth: 3,
        easing: 'easeInOut',
        text: {
            autoStyleContainer: false,
            style: {
                // Text color.
                // Default: same as stroke color (options.color)
                color: $rootScope.$themes[$rootScope.$currentTheme || 'pdplatform'].primaryColor,
                position: 'absolute',
                left: '50%',
                top: '50%',
                padding: 0,
                margin: 0,
                // You can specify styles which will be browser prefixed
                transform: {
                    prefix: true,
                    value: 'translate(-50%, -50%)'
                },
                fontSize: '1.5em',
            }
        }
      };

      $rootScope.$on('profilePercentageChanged', function (event, args) {
        var newPercentageComplete = args.percentageComplete;
        if (newPercentageComplete !== vm.percentageComplete) {
          vm.percentageComplete = newPercentageComplete;
          $pbService.set('navbarProgress', vm.percentageComplete / 100);
        }
      })

      $timeout(function () {
        $pbService.set('navbarProgress', vm.percentageComplete / 100);
      });
    }

    navbarController.$inject = ['$rootScope', '$timeout', '$attrs', '$pbService'];

    angular.module('ecap.common').controller('navbarController', navbarController);
})();